export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ServicioSocialReportesPage.vue?vue&type=template&id=d8e4dd5a&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/ServicioSocialReportesPage.vue?vue&type=template&id=d8e4dd5a&scoped=true&
// module id = 646
// module chunks = 9